import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPushConfig(officeId) {
  return request({
    url: URL.sys.pushConfig,
    method: 'get',
    params: { officeId }
  })
}

export function savePushConfig(data) {
  return request({
    url: URL.sys.pushConfig,
    method: 'post',
    data
  })
}

export function savePersonalMailbox(data) {
  return request({
    url: URL.sys.updatePersonalEmail,
    method: 'post',
    data
  })
}
